/* The Puptail Society 2026 theme: shared behaviour (Foundation).
 * Ported from the approved draft (wip/puptails/assets/js/site.js), cream direction only, wired to Shopify:
 *   - live catalog from window.PTS_SHOP (snippets/pts-catalog.liquid) merged with window.PTS_CONTENT (assets/pts-content.js)
 *     into the draft's DRINKS / EXTRAS shapes, so the draft's rendering code ports with minimal change
 *   - cart = Shopify AJAX API (/cart.js, /cart/add.js, /cart/change.js), drawer UI from the draft
 *   - header, footer, shared sections are server rendered in Liquid; this file only adds interactivity
 * Public API: window.PTS (see FOUNDATION.md). Section scripts should wrap their code in PTSReady(function (P) { ... }).
 */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  root.classList.add('js');
  root.setAttribute('data-theme', 'luxe');

  var SHOP = window.PTS_SHOP || { products: [] };
  var C = window.PTS_CONTENT || { DRINKS: {}, EXTRAS: {} };
  var ASSET = SHOP.assetBase || '';
  var ROOT = SHOP.root || '/'; if (ROOT.slice(-1) !== '/') ROOT += '/';
  var URLS = SHOP.urls || {};
  var FREE_SHIP_CENTS = +SHOP.freeShip || 0;
  var FREE_SHIP = FREE_SHIP_CENTS / 100;           /* dollars, as the draft used it */
  var IG = C.IG || 'https://www.instagram.com/puptailsociety/';
  var SPOTIFY = C.SPOTIFY || '';
  var WHOLESALE = URLS.wholesale || '/apps/wpdapp/wholesale';
  var RETIRED = /pawsecco|cosmopawlitan|pawjito|hamptons/i;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function attr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }
  /* img('luxe/hero-wide.jpg') -> theme asset URL of pts-luxe-hero-wide.jpg. Accepts draft paths (with or without
     ../assets/img/), 'video/x.mp4', 'logo/puptail-society-gold.svg', '@x.jpg' (cream themed) or a pts-* asset name. */
  function img(p) {
    if (!p) return '';
    if (/^(https?:)?\/\//.test(p) || p.charAt(0) === '/') return p;
    p = p.replace(/^(\.\.\/)+/, '').replace(/^assets\//, '').replace(/^img\//, '');
    if (p.charAt(0) === '@') p = 'luxe/' + p.slice(1);
    if (p.indexOf('pts-') === 0) return ASSET + p;
    var m = p.match(/^logo\/puptail-society-(\w+)\.svg$/); if (m) return ASSET + 'pts-logo-' + m[1] + '.svg';
    return ASSET + 'pts-' + p.replace('/', '-');
  }
  /* money: dollars in, '$15.95' out (as the draft). moneyCents: Shopify cents in. Both currencies here use '$'. */
  function money(n) { return '$' + (+n || 0).toFixed(2); }
  function moneyCents(c) { return money((+c || 0) / 100); }
  function url(key) { return URLS[key] || (key === 'home' ? ROOT : ROOT); }

  /* ---------- catalog: PTS_SHOP (live) + PTS_CONTENT (copy) -> DRINKS / EXTRAS ---------- */
  var LIVE = {};
  (SHOP.products || []).forEach(function (p) { LIVE[p.handle] = p; });
  var HAS_LIVE = (SHOP.products || []).length > 0;
  var CLUB_PCT = 0, CLUB_PLAN = null;
  (SHOP.products || []).some(function (p) {
    return (p.selling_plans || []).some(function (sp) { if (sp.percent != null) { CLUB_PCT = +sp.percent; CLUB_PLAN = sp; return true; } });
  });
  function variantBy(lp, title) {
    if (!lp) return null;
    title = String(title).toLowerCase();
    return (lp.variants || []).filter(function (v) { return String(v.title).toLowerCase() === title || String(v.option1).toLowerCase() === title; })[0] || null;
  }
  function firstAvailable(lp) { return lp ? ((lp.variants || []).filter(function (v) { return v.available; })[0] || (lp.variants || [])[0] || null) : null; }
  function liveFields(o, lp) {
    o.live = !!lp;
    if (!lp) { o.available = true; o.variants = []; o.url = ROOT + 'products/' + o.h; return o; }
    o.id = lp.id; o.url = lp.url; o.title = lp.title; o.available = lp.available;
    o.variants = lp.variants || []; o.images = lp.images || []; o.featured = lp.featured_image;
    o.compare_at = lp.compare_at_price ? lp.compare_at_price / 100 : 0;
    o.rating = lp.loox_rating != null ? +lp.loox_rating : null; o.reviews = lp.loox_count != null ? +lp.loox_count : null;
    var sp = (lp.selling_plans || []).filter(function (x) { return x.percent != null; })[0] || (lp.selling_plans || [])[0];
    o.plan = sp ? { id: sp.id, percent: sp.percent != null ? +sp.percent : 0, group: sp.group, name: sp.name } : null;
    o.requires_plan = !!lp.requires_selling_plan;
    return o;
  }
  var DRINKS = [], EXTRAS = [];
  Object.keys(C.DRINKS || {}).forEach(function (h) {
    var lp = LIVE[h];
    if (HAS_LIVE && !lp) return;                         /* not on sale in this store / market */
    var d = Object.assign({}, C.DRINKS[h]);
    liveFields(d, lp);
    d.v150 = variantBy(lp, '150ml'); d.v75 = variantBy(lp, '75ml');
    d.only150 = !!d.only150 || (lp ? !d.v75 : !!d.only150);
    d.p150 = d.v150 ? d.v150.price / 100 : (lp ? lp.price / 100 : d.fallback.p150);
    d.p75 = d.v75 ? d.v75.price / 100 : (d.fallback ? d.fallback.p75 : d.p150);
    d.price = d.only150 ? d.p150 : d.p75;
    DRINKS.push(d);
  });
  Object.keys(C.EXTRAS || {}).forEach(function (h) {
    var lp = LIVE[h], e = Object.assign({}, C.EXTRAS[h]);
    if (!lp && (HAS_LIVE || e.optional)) return;          /* e.g. Society Mat until the product exists */
    liveFields(e, lp);
    if (lp) {
      var prices = (lp.variants || []).map(function (v) { return v.price; });
      var min = prices.length ? Math.min.apply(null, prices) : lp.price, max = prices.length ? Math.max.apply(null, prices) : lp.price;
      e.price = min / 100; e.from = max > min;
    } else { e.price = e.fallback.price; }
    if (h === 'the-yappy-hour-sampler') {
      var her = variantBy(lp, 'Heritage Range'), mix = variantBy(lp, 'Hamptons Range') || variantBy(lp, 'Mixed Range') || variantBy(lp, 'Mixed');
      e.flights = { heritage: her || firstAvailable(lp), mixed: mix && mix.available ? mix : null };
      var mut = LIVE.muttini && variantBy(LIVE.muttini, '75ml');
      if (mut && lp) { var save = (mut.price * 5 - min) / 100; if (save > 0) e.badge = 'Save ' + money(save); e.save = save; }
    }
    if (h === 'the-slurp-mat') e.sips = (e.variants || []).filter(function (v) { return !RETIRED.test(v.title); });
    if (h === 'the-puptail-society-gift-card') e.amounts = (e.variants || []).map(function (v) { return { id: v.id, price: v.price / 100, title: v.title, available: v.available }; });
    EXTRAS.push(e);
  });
  var BY = {};
  DRINKS.concat(EXTRAS).forEach(function (p) { BY[p.h] = p; BY[p.slug] = p; });
  function find(h) { return h ? BY[h] || BY[(C.SLUGS || {})[h]] || null : null; }

  /* ---------- images for products (draft helpers, cream only) ---------- */
  function slugOf(h) { var p = find(h); return p ? p.slug : h; }
  function packImg(h) { return img('pack/' + slugOf(h) + '-luxe.jpg'); }
  function drinkImg(h) { return img('pouch/' + slugOf(h) + '-luxe.jpg'); }
  function extraImg(src) { return img(src); }
  function realImg(n) { return img('real/' + n + '.jpg'); }
  function dogImg(h) { var p = find(h), k = p ? p.h : h; return C.LIFE[k] || C.COLOUR[k] ? realImg(C.LIFE[k] || C.COLOUR[k]) : ''; }
  function prodImg(p) {
    if (typeof p === 'string') p = find(p);
    if (!p) return '';
    if (p.kind === 'drink') return packImg(p.h);
    return p.img ? img(p.img) : (p.featured || '');
  }
  function href(p) { if (typeof p === 'string') p = find(p); return p ? p.url : url('shop'); }
  function fixed(u) { return u; }          /* draft compat: no After Dark query param any more */
  function fixLink() {}                    /* draft compat */

  /* ---------- icons ---------- */
  var I = {
    bag: '<svg viewBox="0 0 24 24"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2"/></svg>',
    user: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>',
    menu: '<svg viewBox="0 0 24 24"><path d="M3 7h18M3 12h18M3 17h18"/></svg>',
    close: '<svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    ig: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".6"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-9.2-8.6C1.3 8.4 3 5 6.4 5c2 0 3.6 1.1 4.6 2.7C12 6.1 13.6 5 15.6 5 19 5 20.7 8.4 19.2 11.4 17 15.6 12 20 12 20z"/></svg>'
  };

  /* ---------- content tokens ({freeShip}, {url:stockists}) ---------- */
  function fill(s) {
    return String(s).replace(/\{freeShip\}/g, String(FREE_SHIP).replace(/\.0+$/, '')).replace(/\{url:(\w+)\}/g, function (m, k) { return url(k); });
  }
  var FAQ = (C.FAQ || []).map(function (g) { return { id: g.id, t: g.t, q: g.q.map(function (x) { return [x[0], fill(x[1])]; }) }; });

  /* ---------- product card (same markup as snippets/pts-card.liquid) ---------- */
  var HOVER = !!(window.matchMedia && matchMedia('(hover: hover)').matches);
  function priceText(p) {
    if (p.kind === 'drink') return p.only150 ? money(p.p150) : 'From ' + money(p.p75);
    return (p.from ? 'From ' : '') + money(p.price);
  }
  function card(p) {
    if (typeof p === 'string') p = find(p);
    if (!p) return '';
    var isDrink = p.kind === 'drink', t = attr(p.t), sold = p.live && !p.available;
    var media = isDrink
      ? '<img data-pack="' + p.h + '" src="' + packImg(p.h) + '" alt="' + t + ' 150ml pouch" loading="lazy">' +
        (HOVER && dogImg(p.h) ? '<img class="alt" src="' + dogImg(p.h) + '" alt="" loading="lazy">' : '')
      : '<img' + (p.fit ? ' class="contain"' : '') + ' src="' + prodImg(p) + '" alt="' + t + '" loading="lazy">';
    var quick = sold ? 'Sold out' : isDrink ? 'Add 150ml · ' + money(p.p150) : p.h === 'the-yappy-hour-sampler' ? 'Choose your flight' : 'Add to bag';
    return '<article class="card">' +
      '<div class="ph"><a href="' + href(p) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
        (p.badge ? '<span class="badge' + (p.badge.indexOf('Save') === 0 ? ' gold' : '') + '">' + esc(p.badge) + '</span>' : '') +
        '<button class="wish' + (WISH.indexOf(p.h) > -1 ? ' on' : '') + '" type="button" data-wish="' + p.h + '" aria-label="Save ' + t + ' for later">' + I.heart + '</button>' +
        '<span class="quick"><button class="btn btn-dark btn-block" type="button" data-add="' + p.h + '"' + (sold ? ' disabled' : '') + '>' + quick + '</button></span></div>' +
      '<div class="meta">' + (isDrink ? '<div class="job">' + esc(p.job) + '</div>' : '') +
        '<h3><a href="' + href(p) + '">' + esc(p.t) + '</a></h3><p class="notes">' + esc(p.line) + '</p><div class="price">' + priceText(p) + '</div></div></article>';
  }
  /* <div class="grid" data-grid="drinks|gifts|all" data-limit="4"></div> renders client side (draft compat) */
  function renderGrid(g) {
    var which = g.getAttribute('data-grid');
    var list = which === 'drinks' ? DRINKS : which === 'gifts' ? EXTRAS.filter(function (p) { return p.h !== 'the-yappy-hour-sampler'; }) : DRINKS.concat(EXTRAS);
    var lim = +g.getAttribute('data-limit') || list.length;
    g.innerHTML = list.slice(0, lim).map(card).join('');
    reveal(g); rimg(g);
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = doc.querySelector('.toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on'); clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }

  /* ---------- wishlist (this browser only) ---------- */
  var WISH = (function () { try { return JSON.parse(localStorage.getItem('pts_wish') || '[]'); } catch (e) { return []; } })();
  WISH = WISH.map(function (h) { var p = find(h); return p ? p.h : h; });
  function saveWish() { try { localStorage.setItem('pts_wish', JSON.stringify(WISH)); } catch (e) {} }
  function toggleWish(h) {
    var p = find(h); if (p) h = p.h;
    var i = WISH.indexOf(h); if (i > -1) WISH.splice(i, 1); else WISH.push(h);
    saveWish(); renderWish();
    toast(i > -1 ? 'Removed from your saved list.' : 'Saved for later. Find it under the heart.');
  }
  function renderWish() {
    doc.querySelectorAll('[data-wish]').forEach(function (b) { var p = find(b.getAttribute('data-wish')); b.classList.toggle('on', WISH.indexOf(p ? p.h : b.getAttribute('data-wish')) > -1); });
    doc.querySelectorAll('.wish-count').forEach(function (c) { c.textContent = WISH.length; c.hidden = !WISH.length; });
    var box = doc.querySelector('.wl-res'); if (!box) return;
    var items = WISH.map(find).filter(Boolean);
    box.innerHTML = items.length ? items.map(function (p) {
      return '<div class="wl-item"><a href="' + href(p) + '"><img src="' + prodImg(p) + '" alt="" loading="lazy"><span><b>' + esc(p.t) + '</b><small>' + priceText(p) + '</small></span></a>' +
        '<button class="btn btn-dark btn-sm" type="button" data-add="' + p.h + '"' + (p.live && !p.available ? ' disabled' : '') + '>Add</button><button class="wl-x" type="button" data-wish="' + p.h + '" aria-label="Remove">' + I.close + '</button></div>';
    }).join('') : '<p style="color:var(--muted)">Nothing saved yet. Tap the heart on any Puptail to keep it for later.</p>';
  }

  /* ---------- cart: Shopify AJAX API ---------- */
  var CART = window.PTS_CART || null;
  function api(path, body) {
    return fetch(ROOT + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Something went wrong. Please try again.'); err.status = r.status; err.data = j; throw err; }
        return j;
      });
    });
  }
  function busy(on) { var d = doc.querySelector('.drawer'); if (d) d.classList.toggle('busy', !!on); }
  function setCart(c) { CART = c; renderCart(); doc.dispatchEvent(new CustomEvent('pts:cart', { detail: c })); return c; }
  /* cart writes run one at a time so fast taps cannot land out of order */
  var Q = Promise.resolve();
  function queue(fn) { var run = Q.then(fn, fn); Q = run.catch(function () {}); return run; }
  function refreshCart() { return queue(function () { return api('cart.js'); }).then(setCart); }
  /* addToCart({variantId, qty, sellingPlan, properties}) or addToCart([{...}, {...}]). Opens the drawer on success. */
  function addToCart(o) {
    var list = Array.isArray(o) ? o : [o];
    var items = list.map(function (x) {
      var it = { id: +x.variantId || +x.id, quantity: Math.max(1, +x.qty || +x.quantity || 1) };
      if (x.sellingPlan) it.selling_plan = +x.sellingPlan;
      if (x.properties && Object.keys(x.properties).length) it.properties = x.properties;
      return it;
    });
    if (items.some(function (it) { return !it.id; })) { toast('Sorry, that option is not available.'); return Promise.reject(new Error('missing variant')); }
    busy(true);
    return queue(function () { return api('cart/add.js', { items: items }); }).then(function (added) {
      return refreshCart().then(function (c) {
        busy(false); openCart();
        doc.querySelectorAll('.cart-count:not(.wish-count)').forEach(function (el) { el.classList.add('bump'); setTimeout(function () { el.classList.remove('bump'); }, 350); });
        doc.dispatchEvent(new CustomEvent('pts:cart:added', { detail: { items: added.items || [added], cart: c } }));
        return c;
      });
    }).catch(function (e) { busy(false); toast(e.message || 'Could not add that to your bag.'); throw e; });
  }
  function changeLine(key, qty) {
    busy(true);
    return queue(function () { return api('cart/change.js', { id: key, quantity: Math.max(0, qty) }); }).then(function (c) { busy(false); return setCart(c); })
      .catch(function (e) { busy(false); toast(e.message); refreshCart(); throw e; });
  }
  /* resolve live variants for a product the catalog did not include (fallback) */
  function ensureLive(p) {
    if (!p || (p.variants && p.variants.length)) return Promise.resolve(p);
    return fetch(ROOT + 'products/' + p.h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var lp = { id: j.id, handle: j.handle, title: j.title, url: j.url, available: j.available, price: j.price, compare_at_price: j.compare_at_price,
        images: j.images, featured_image: j.featured_image, requires_selling_plan: j.requires_selling_plan,
        variants: (j.variants || []).map(function (v) { return { id: v.id, title: v.title, option1: v.option1, price: v.price, available: v.available }; }),
        selling_plans: [].concat.apply([], (j.selling_plan_groups || []).map(function (g) { return g.selling_plans.map(function (sp) { var a = (sp.price_adjustments || [])[0]; return { id: sp.id, name: sp.name, group: g.name, percent: a && a.value_type === 'percentage' ? a.value : null }; }); })) };
      liveFields(p, lp);
      if (p.kind === 'drink') { p.v150 = variantBy(lp, '150ml'); p.v75 = variantBy(lp, '75ml'); }
      if (p.h === 'the-yappy-hour-sampler') { var m = variantBy(lp, 'Hamptons Range'); p.flights = { heritage: variantBy(lp, 'Heritage Range') || firstAvailable(lp), mixed: m && m.available ? m : null }; }
      if (p.h === 'the-slurp-mat') p.sips = p.variants.filter(function (v) { return !RETIRED.test(v.title); });
      return p;
    });
  }
  /* add(handle, opts): the draft's signature, mapped to live variants.
     opts: {size:'150ml'|'75ml', plan:'month' (Society Club), qty, variant:'Muttini' (Pawty Pack sip) | 'Heritage flight' | 'Mixed flight',
            flight:'heritage'|'mixed', price: 55 (gift card amount), variantId, sellingPlan, properties} */
  function add(h, opts) {
    opts = opts || {};
    var p = find(h); if (!p) return Promise.reject(new Error('unknown product ' + h));
    if (p.h === 'the-yappy-hour-sampler' && !opts.variant && !opts.flight && !opts.variantId) { location.href = p.url; return Promise.resolve(); }
    return ensureLive(p).then(function (p) {
      var v = null, props = Object.assign({}, opts.properties || {}), plan = opts.sellingPlan || null;
      if (opts.variantId) v = { id: opts.variantId };
      else if (p.kind === 'drink') v = (opts.size === '75ml' ? p.v75 : p.v150) || firstAvailable(p);
      else if (p.h === 'the-yappy-hour-sampler') {
        var f = (opts.flight || String(opts.variant || '')).toLowerCase().indexOf('mix') > -1 ? 'mixed' : 'heritage';
        if (f === 'mixed' && p.flights.mixed) v = p.flights.mixed;
        else { v = p.flights.heritage; if (f === 'mixed') props.Flight = 'Mixed'; }
      }
      else if (p.h === 'the-slurp-mat') v = (opts.variant && variantBy(p, opts.variant)) || (p.sips || []).filter(function (x) { return x.title === 'Muttini'; })[0] || (p.sips || [])[0];
      else if (opts.price && p.amounts) v = p.variants.filter(function (x) { return x.price === Math.round(opts.price * 100); })[0];
      else if (opts.variant) v = variantBy(p, opts.variant);
      if (!v) v = firstAvailable(p);
      if (!plan && opts.plan && p.plan) plan = p.plan.id;
      return addToCart({ variantId: v && v.id, qty: opts.qty || 1, sellingPlan: plan, properties: props });
    });
  }

  /* customer-facing variant name: sampler variants read as flights, never the retired range name */
  function variantLabel(title, props) {
    if (!title || title === 'Default Title') return '';
    if (props && props.Flight) return '';                              /* "Flight: Mixed" says it */
    if (/hamptons|mixed/i.test(title) && /range/i.test(title)) return 'Mixed flight';
    if (/^heritage range$/i.test(title)) return 'Heritage flight';
    return RETIRED.test(title) ? '' : title;
  }
  function lineLabel(it) {
    var bits = [], props = it.properties || {};
    var vl = it.product_has_only_default_variant ? '' : variantLabel(it.variant_title, props);
    if (vl) bits.push(vl);
    if (it.selling_plan_allocation) bits.push('Society Club, every month');
    Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_' && props[k] !== '' && props[k] != null) bits.push(k === 'Flight' ? props[k] + ' flight' : k + ': ' + props[k]); });
    return bits.map(esc).join(' · ');
  }
  function renderCart() {
    var c = CART || { items: [], item_count: SHOP.cartCount || 0, total_price: 0, currency: SHOP.currency };
    var n = c.item_count || 0;
    doc.querySelectorAll('.cart-count:not(.wish-count)').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    var d = doc.querySelector('.drawer'); if (!d || !CART) return;
    var sub = c.total_price || 0, items = c.items || [];
    var rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
    var thr = Math.round(FREE_SHIP_CENTS * rate), ship = d.querySelector('.ship');
    /* free shipping is an Australian offer: only show the bar to AUD carts */
    if (thr > 0 && (c.currency || SHOP.currency) === 'AUD') {
      var left = Math.max(0, thr - sub);
      ship.hidden = false;
      ship.innerHTML = (left > 0 ? 'You’re <b>' + moneyCents(left) + '</b> away from free shipping' : '<b>Free shipping unlocked.</b> Consider it our shout.') +
        '<div class="bar"><i style="width:' + Math.min(100, sub / thr * 100) + '%"></i></div>';
    } else { ship.hidden = true; ship.innerHTML = ''; }
    d.querySelector('.lines').innerHTML = items.length ? items.map(function (it) {
      var p = find(it.handle), im = p ? prodImg(p) : (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '');
      var title = p ? p.t : it.product_title;
      var was = it.original_line_price || 0, spa = it.selling_plan_allocation;
      if (spa && spa.compare_at_price && spa.compare_at_price * it.quantity > was) was = spa.compare_at_price * it.quantity;
      return '<div class="line"><img src="' + im + '" alt="" loading="lazy"><div><b><a href="' + it.url + '">' + esc(title) + '</a></b><small>' + lineLabel(it) + '</small>' +
        '<div class="qty"><button type="button" data-q="' + it.key + '" data-d="-1" aria-label="Less">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + it.key + '" data-d="1" aria-label="More">+</button></div>' +
        '<button class="rm" type="button" data-rm="' + it.key + '">Remove</button></div><div>' +
        (was > it.final_line_price ? '<s>' + moneyCents(was) + '</s>' : '') + moneyCents(it.final_line_price) + '</div></div>';
    }).join('') : '<div class="empty"><p class="serif" style="font-size:24px;color:var(--ink)">The bar is open.</p><p>Your bag is empty. Start with the Sampler.</p><a class="btn btn-dark" style="margin-top:18px" href="' + url('sampler') + '">Shop the Sampler</a></div>';
    var hasGlass = items.some(function (it) { return it.handle === 'the-puptails-glass' || it.handle === 'the-slurp-mat'; });
    var up = find(hasGlass ? 'puptails-dog-grazing-box-gourmet-dog-treat-gift-box' : 'the-puptails-glass');
    var inCart = up && items.some(function (it) { return it.handle === up.h; });
    var showUp = items.length && up && !(up.live && !up.available) && !inCart;
    var u = d.querySelector('.upsell');
    u.innerHTML = showUp ? '<div class="u"><img src="' + prodImg(up) + '" alt="" loading="lazy"><div><b>' + (hasGlass ? 'Make it a date night' : 'Serve it properly') + '</b><br>' + esc(up.t) + ' · ' + money(up.price) + '</div><button type="button" data-add="' + up.h + '">Add</button></div>' : '';
    u.style.display = showUp ? '' : 'none';
    d.querySelector('.drawer-ft').innerHTML = items.length ? '<div class="row"><span>Subtotal</span><span>' + moneyCents(sub) + '</span></div><button class="btn btn-primary btn-block" type="button" data-checkout>Checkout</button><small>Pay in 4 with Afterpay at checkout. Shipping calculated at checkout.</small>' : '';
  }
  function openCart() {
    doc.body.classList.add('cart-open');
    var d = doc.querySelector('.drawer'); if (d) { d.setAttribute('aria-hidden', 'false'); }
    if (!CART) refreshCart();
  }
  function closeCart() {
    doc.body.classList.remove('cart-open');
    var d = doc.querySelector('.drawer'); if (d) d.setAttribute('aria-hidden', 'true');
  }

  /* ---------- search (instant, over the merged catalog) ---------- */
  function runSearch(q) {
    var box = doc.querySelector('.srch-res'); if (!box) return;
    q = (q || '').trim().toLowerCase();
    if (!q) { box.innerHTML = ''; return; }
    var all = DRINKS.concat(EXTRAS).filter(function (p) {
      return (p.t + ' ' + (p.title || '') + ' ' + p.line + ' ' + (p.job || '') + ' ' + (p.boost || '') + ' ' + (p.ing || '') + ' ' + (p.range || '') + ' ' + (p.kind === 'gift' ? 'gift' : '') + ' ' + (p.h === 'the-yappy-hour-sampler' ? 'sampler flight' : '') + ' ' + (p.about || '')).toLowerCase().indexOf(q) > -1;
    });
    box.innerHTML = all.length ? all.map(function (p) {
      return '<a href="' + href(p) + '"><img src="' + prodImg(p) + '" alt="" loading="lazy"><span><b>' + esc(p.t) + '</b><small>' + (p.job ? esc(p.job) + ' · ' : '') + priceText(p) + '</small></span></a>';
    }).join('') : '<p style="color:var(--muted)">Nothing poured under “' + esc(q) + '” yet. Try “gut” or “gift”.</p>';
  }

  /* ---------- reveal on scroll ---------- */
  var IO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); IO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }) : null;
  var RV = '.regs,.ways>*,.flatlay,.ingr-grid>*,.previews,.quotes>*,.sec-head,.grid>*,.flights>*,.ingr>*,.reviews>*,.club>*,.why>*,.steps>*,.how>*,.cheers>*,.values>*,.stock-grid>*,.gifts>*,.split>.media,.split>.copy,.film>*,.yappy>*,.pledges,.page-hd .wrap>*,.faq-group,.exp .card-over,.news .wrap>*,.inside>*,.letter';
  function reveal(r) {
    if (!IO) return;
    (r || doc).querySelectorAll(RV).forEach(function (el) {
      if (el.closest('#pdp') || el.closest('[data-no-reveal]') || el.classList.contains('rv')) return;
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--d', Math.min(sib * 0.07, 0.42) + 's');
      el.classList.add('rv'); IO.observe(el);
    });
  }

  /* ---------- responsive images for theme assets without a srcset ----------
     RIMG lists the widths of each pts-* image (smaller copies are name-720.jpg / name-1280.jpg). Server-rendered
     images already carry a srcset (snippets/pts-img.liquid); this covers images built in JS. */
  var RIMG = C.RIMG || {}, RRAT = C.RRAT || {};
  function rimg(r) {
    var list = r.tagName === 'IMG' ? [r] : (r.querySelectorAll ? r.querySelectorAll('img') : []);
    for (var i = 0; i < list.length; i++) {
      var im = list[i];
      if (im.hasAttribute('srcset') || im.getAttribute('data-rimg')) continue;
      var src = im.getAttribute('src') || '', m = src.match(/\/(pts-[^/?#]+\.(?:jpg|jpeg|png))(?:[?#].*)?$/), k = m && m[1], ws = k && RIMG[k];
      if (!ws || (im.complete && im.naturalWidth) || im.loading !== 'lazy') continue;
      var rc = im.getBoundingClientRect(), w = rc.width || (im.parentElement ? im.parentElement.getBoundingClientRect().width : 0), ra = RRAT[k];
      if (w && rc.height && ra && getComputedStyle(im).objectFit === 'cover' && rc.height / w > ra) w = rc.height / ra;
      w = Math.round(w);
      var dpr = window.devicePixelRatio || 1; if (dpr > 2) w = Math.round(w * 2 / dpr);
      var base = ASSET + k.replace(/\.(jpg|jpeg|png)$/, ''), ext = k.slice(k.lastIndexOf('.'));
      im.sizes = w > 0 ? w + 'px' : '100vw';
      im.srcset = ws.map(function (x, j) { return (j === ws.length - 1 ? src : base + '-' + x + ext) + ' ' + x + 'w'; }).join(', ');
      im.setAttribute('data-rimg', '1');
    }
  }

  /* ---------- drink cards: hover dog photo on hover screens only (server cards carry data-alt) ---------- */
  function hoverAlts(r) {
    if (!HOVER) return;
    (r || doc).querySelectorAll('.card .ph[data-alt]').forEach(function (ph) {
      if (ph.querySelector('img.alt')) return;
      var a = ph.querySelector('a'), im = doc.createElement('img');
      im.className = 'alt'; im.alt = ''; im.loading = 'lazy'; im.src = ph.getAttribute('data-alt');
      (a || ph).appendChild(im);
    });
  }

  /* ---------- lazy Spotify embed (never on phones: they get the Open in Spotify button) ---------- */
  function lazyFrames(r) {
    (r || doc).querySelectorAll('iframe[data-src]').forEach(function (f) {
      if (f.src) return;
      if (window.matchMedia && matchMedia('(max-width:820px)').matches && f.closest('.yappy')) return;
      if (!('IntersectionObserver' in window)) { f.src = f.getAttribute('data-src'); return; }
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { f.src = f.getAttribute('data-src'); o.disconnect(); } }, { rootMargin: '400px' });
      o.observe(f);
    });
  }

  function enhance(r) {
    r = r || doc;
    (r.querySelectorAll ? r.querySelectorAll('[data-grid]') : []).forEach(renderGrid);
    hoverAlts(r); reveal(r); lazyFrames(r); rimg(r); renderWish();
  }

  /* ---------- header: announcement rotation, scrolled state, mega menu, mobile menu ---------- */
  var annIdx = 0, hdr;
  function setMenu(open) {
    doc.body.classList.toggle('menu-open', open);
    var m = doc.querySelector('.mnav'); if (m) m.setAttribute('aria-hidden', open ? 'false' : 'true');
    doc.querySelectorAll('.menu-btn').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function initHeader() {
    hdr = doc.querySelector('.hdr');
    setInterval(function () {
      var ps = doc.querySelectorAll('.announce p'); if (ps.length < 2) return;
      ps[annIdx % ps.length].classList.remove('on'); annIdx++; ps[annIdx % ps.length].classList.add('on');
    }, 4200);
    function onScroll() { if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 40); doc.body.classList.toggle('past-hero', window.scrollY > window.innerHeight * 0.6); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    if (!hdr) return;
    var megaT;
    hdr.querySelectorAll('[data-mega]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { clearTimeout(megaT); hdr.classList.add('mega-open'); });
      a.addEventListener('focus', function () { hdr.classList.add('mega-open'); });
    });
    hdr.querySelectorAll('.nav a:not([data-mega])').forEach(function (a) { a.addEventListener('mouseenter', function () { hdr.classList.remove('mega-open'); }); });
    hdr.addEventListener('mouseleave', function () { megaT = setTimeout(function () { hdr.classList.remove('mega-open'); }, 160); });
    hdr.addEventListener('mouseenter', function () { clearTimeout(megaT); });
    hdr.addEventListener('focusout', function (e) { if (!hdr.contains(e.relatedTarget)) hdr.classList.remove('mega-open'); });
  }

  /* ---------- global events ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wish],[data-wishlist],[data-wl-close],[data-add],[data-cart],[data-close],[data-q],[data-rm],[data-menu],[data-checkout],[data-search],[data-search-close],[data-q-try]');
    if (!t) {
      if (e.target.classList && e.target.classList.contains('srch')) doc.body.classList.remove('search-open', 'wishlist-open');
      return;
    }
    if (t.hasAttribute('data-wish')) { e.preventDefault(); toggleWish(t.getAttribute('data-wish')); }
    else if (t.hasAttribute('data-wishlist')) { renderWish(); doc.body.classList.add('wishlist-open'); }
    else if (t.hasAttribute('data-wl-close')) doc.body.classList.remove('wishlist-open');
    else if (t.hasAttribute('data-add')) {
      e.preventDefault(); if (t.disabled) return;
      doc.body.classList.remove('wishlist-open');
      t.classList.add('is-busy');
      add(t.getAttribute('data-add')).then(function () { t.classList.remove('is-busy'); }, function () { t.classList.remove('is-busy'); });
    }
    else if (t.hasAttribute('data-cart')) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute('data-close')) closeCart();
    else if (t.hasAttribute('data-q')) {
      var key = t.getAttribute('data-q'), it = CART && (CART.items || []).filter(function (x) { return x.key === key; })[0];
      if (it) changeLine(key, it.quantity + (+t.getAttribute('data-d')));
    }
    else if (t.hasAttribute('data-rm')) changeLine(t.getAttribute('data-rm'), 0);
    else if (t.hasAttribute('data-menu')) setMenu(!doc.body.classList.contains('menu-open'));
    else if (t.hasAttribute('data-checkout')) {
      t.classList.add('is-busy');
      /* Tagged (wholesale) customers check out from the cart page, where the wholesale app applies their pricing. */
      if (window.PTS_WHOLESALE_CHECKOUT) {
        var cb = doc.querySelector('[data-pc-form] [name="checkout"]');
        if (cb) cb.click(); else location.href = url('cart');
      } else location.href = url('checkout');
    }
    else if (t.hasAttribute('data-search')) { doc.body.classList.add('search-open'); setTimeout(function () { var i = doc.querySelector('[data-q-input]'); if (i) i.focus(); }, 150); }
    else if (t.hasAttribute('data-search-close')) doc.body.classList.remove('search-open');
    else if (t.hasAttribute('data-q-try')) { var inp = doc.querySelector('[data-q-input]'); inp.value = t.textContent; runSearch(inp.value); }
  });
  doc.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-q-input]')) runSearch(e.target.value); });
  doc.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-cur]')) { var f = e.target.form; if (f) f.submit(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); setMenu(false); doc.body.classList.remove('search-open', 'wishlist-open'); if (hdr) hdr.classList.remove('mega-open'); }
  });
  /* theme editor: re-run enhancements on a reloaded section */
  doc.addEventListener('shopify:section:load', function (e) { enhance(e.target); });

  /* ---------- public API ---------- */
  window.PTS = {
    ready: false,
    /* data */
    SHOP: SHOP, CONTENT: C, DRINKS: DRINKS, EXTRAS: EXTRAS, FAQ: FAQ,
    SERVE: C.SERVE, SAFETY: C.SAFETY, REVIEWS: C.REVIEWS, PHOTO_REVIEWS: C.PHOTO_REVIEWS, WAYS: C.WAYS, SOCIETY: C.SOCIETY,
    INGREDIENTS: C.INGREDIENTS, WHY: C.WHY, LIFE: C.LIFE, COLOUR: C.COLOUR, LAUNCH: C.LAUNCH,
    FREE_SHIP: FREE_SHIP, CLUB_PCT: CLUB_PCT, CLUB_PLAN: CLUB_PLAN, WHOLESALE: WHOLESALE, IG: IG, SPOTIFY: SPOTIFY, RETIRED: RETIRED,
    /* lookups and formatting */
    find: find, money: money, moneyCents: moneyCents, img: img, url: url, href: href, esc: esc, variantBy: variantBy,
    packImg: packImg, drinkImg: drinkImg, extraImg: extraImg, prodImg: prodImg, realImg: realImg, dogImg: dogImg, priceText: priceText,
    /* rendering */
    card: card, renderGrid: renderGrid, reveal: reveal, rimg: rimg, enhance: enhance, icons: I, toast: toast,
    /* cart */
    add: add, addToCart: addToCart, changeLine: changeLine, refreshCart: refreshCart, openCart: openCart, closeCart: closeCart,
    cart: function () { return CART; },
    /* wishlist */
    toggleWish: toggleWish, renderWish: renderWish, wishlist: function () { return WISH.slice(); },
    /* draft compat (After Dark removed) */
    fixed: fixed, fixLink: fixLink, theme: function () { return 'luxe'; }, dir: function () { return 'luxe'; },
    mountSections: function () {}, base: ASSET
  };

  /* app floaters (Klaviyo teaser, Notify Me pill) sit just above the PDP sticky bar, whose height changes when it wraps */
  function stickyLift() {
    var sb = doc.querySelector('.sticky-buy');
    if (!sb) return;
    var set = function () {
      var r = sb.getBoundingClientRect();
      if (r.height) doc.documentElement.style.setProperty('--pts-sticky-lift', Math.round(window.innerHeight - r.top + 9) + 'px');
      else doc.documentElement.style.removeProperty('--pts-sticky-lift');
    };
    set();
    window.addEventListener('resize', set);
    try { new ResizeObserver(set).observe(sb); } catch (e) {}
  }

  function boot() {
    initHeader();
    enhance(doc);
    if (CART) renderCart(); else renderCart();
    try { new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) rimg(n); }); }); }).observe(doc.body, { childList: true, subtree: true }); } catch (e) {}
    stickyLift();
    window.PTS.ready = true;
    doc.dispatchEvent(new CustomEvent('pts:ready', { detail: window.PTS }));
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
